import _ from 'lodash';
import React, { Component } from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import Button from 'shared/components/Button';
import HorizontalBox from 'shared/components/HorizontalBox';
import SkipStep from 'shared/components/SkipStep';
import BackStep from 'shared/components/BackStep';

import {
  nextStep,
  patchUserServiceProviders,
  previousStep
} from 'shared/components/Signup/ducks';

import { getImage } from './utils';
import styles from './styles.module.scss';

class ChooseServiceProviders extends Component {
  state = {
    chosenServiceProviders: []
  };

  toggleServiceProviders = serviceType => {
    const newChosenServiceProviders = _.xor(this.state.chosenServiceProviders, [
      serviceType.value
    ]);
    this.setState({ chosenServiceProviders: newChosenServiceProviders });
  };

  isServiceProviderSelected = serviceProvider => {
    return (
      _.indexOf(this.state.chosenServiceProviders, serviceProvider.value) > -1
    );
  };

  render() {
    const { serviceProviders, nextStep, previousStep } = this.props;

    const { chosenServiceProviders } = this.state;

    return (
      <div className={styles.serviceProvidersWrapper}>
        <BackStep onClickEvent={previousStep} />

        <div className={classnames('secondary-page-title', styles.pageTitle)}>
          What type of service do you provide?
        </div>
        <div className="page-title-label">
          Select the services that are most relevant to you.
        </div>
        <div className={styles.serviceProvidersRow}>
          {serviceProviders.map(serviceType => {
            let imageSrc = getImage(serviceType.label.split('/')[0]);
            return (
              <HorizontalBox
                key={serviceType.label}
                image={imageSrc}
                title={serviceType.label}
                onClickEvent={() => this.toggleServiceProviders(serviceType)}
                selected={this.isServiceProviderSelected(serviceType)}
              />
            );
          })}
        </div>
        <div className={styles.nextStepAndSkipStepWrapper}>
          <Button
            className={styles.nextStepBtn}
            color="primary"
            onClick={() =>
              this.props.patchUserServiceProviders({
                service_areas: chosenServiceProviders
              })
            }
            disabled={_.isEmpty(chosenServiceProviders)}>
            Next Step
          </Button>
          <SkipStep onClickEvent={nextStep} className={styles.skipStepLink} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const serviceProviders =
    state.constants.constants.service_providers.SERVICE_TYPE_CHOICES;

  return {
    serviceProviders
  };
};

const mapDispatchToProps = {
  patchUserServiceProviders,
  nextStep,
  previousStep
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChooseServiceProviders);
